import axios from 'axios';

export const postMethodFile = async (url, token, values) => {
    const response = await axios({
        method: 'POST',
        url,
        data: values,
        headers: {
            "Authorization": `Bearer ${token}`,
            'Content-Type': 'multipart/form-data',
        }
    })
    return response;


}
